import { Button, Result } from 'antd';
import { FC } from 'react';

const GenericErrorMessage: FC = () => {
	return (
		<Result
			status="500"
			title="Terjadi Kesalahan"
			subTitle="Maaf, terdapat kesalahan pada halaman yang anda coba akses, silakan coba kembali"
			extra={
				<Button
					type="primary"
					onClick={() => window.location.reload()}
				>
					Refresh
				</Button>
			}
		/>
	);
};

export default GenericErrorMessage;
